import React from "react";
import { Show, SimpleShowLayout, TextField, DateField, RichTextField } from 'react-admin';

export const TransactionShow = (props) => (
	<Show {...props}>
		<SimpleShowLayout>
			<TextField source="uuid" />
			<TextField source="date" />
			<TextField source="from" />
			<TextField source="to" />
			<TextField source="value" />
			<TextField source="status" />
		</SimpleShowLayout>
	</Show>
);